import { ReactNode } from 'react';
import styles from './styles.module.scss';
import clsx from 'clsx';

interface EpInfoCardProps {
  children: ReactNode;
  customHeaderType?: 'primary' | 'danger' | 'success' | 'warning';
  title?: string;
  type?: string;
}

export default function EpInfoCard({
  children,
  customHeaderType = 'primary',
  title,
  type,
}: EpInfoCardProps) {
  const cardClass = 'ep-info-card';
  const headerTitleClass = 'ep-info-card__header-title';

  return (
    <div className={clsx(styles[cardClass], type && styles[type])}>
      <h3
        className={clsx(
          styles[headerTitleClass],
          styles[`${headerTitleClass}--${customHeaderType}`],
        )}
      >
        {title}
      </h3>
      <div>{children}</div>
    </div>
  );
}
